module.exports = __webpack_public_path__ + "static/media/1.8289b5e7.png";